import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';
import { Spinner } from './spinner';

const loadingVariants = cva(
  'flex items-center justify-center gap-2',
  {
    variants: {
      variant: {
        default: 'text-muted-foreground',
        primary: 'text-primary',
        secondary: 'text-secondary-foreground',
      },
      size: {
        sm: 'text-sm',
        default: 'text-base',
        lg: 'text-lg',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export interface LoadingProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof loadingVariants> {
  text?: string;
  showSpinner?: boolean;
}

const Loading = React.forwardRef<HTMLDivElement, LoadingProps>(
  ({ className, variant, size, text = 'Loading...', showSpinner = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(loadingVariants({ variant, size, className }))}
        {...props}
      >
        {showSpinner && (
          <Spinner 
            size={size === 'sm' ? 'sm' : size === 'lg' ? 'lg' : 'default'} 
          />
        )}
        {text && <span>{text}</span>}
      </div>
    );
  }
);
Loading.displayName = 'Loading';

export { Loading, loadingVariants };